export const curriculumTranslations: Record<string, Record<string, string>> = {
  en: {
    "cur.title": "30-Day Vikas Challenge",
    "cur.subtitle": "Each day follows the Vikas Method: A Hook, A Concept, and A Tool to master it.",
    "cur.lessonsComplete": "lessons done",
    "cur.share": "Share Progress",
    "cur.theHook": "The Hook",
    "cur.theConcept": "The Concept",
    "cur.tryTool": "Try it Now",
    "cur.graduated": "🎓 You Graduated!",
    "cur.graduatedDesc": "You've completed the 30-Day Vikas Challenge. Share your achievement!",
    "cur.shareCertificate": "Share on WhatsApp",

    // Phases
    "cur.phase1": "Phase 1: The Foundation (Days 1–7)",
    "cur.phase2": "Phase 2: The Growth Engine (Days 8–14)",
    "cur.phase3": "Phase 3: Indian vs Global Split (Days 15–21)",
    "cur.phase4": "Phase 4: Advanced Mastery (Days 22–30)",

    // Day 1
    "cur.d1.title": "The Invisible Thief (Inflation)",
    "cur.d1.hook": "You find a ₹500 note in old jeans from 2016. Back then it bought 5 movie tickets. Today? Barely 1.",
    "cur.d1.concept": "Inflation silently eats your savings at 6-7% per year in India. Globally, purchasing power drops against every currency. If your money isn't growing, it's dying.",
    "cur.d1.tool": "Try the Inflation Machine",

    // Day 2
    "cur.d2.title": "Your Money Personality",
    "cur.d2.hook": "Why does your friend save ₹20K/month on the same salary where you save zero?",
    "cur.d2.concept": "Everyone has a money personality — Spender, Saver, Avoider, or Monk. Identifying yours is the first step to changing your financial destiny.",

    // Day 3
    "cur.d3.title": "The 'Flex' Trap (Needs vs. Wants)",
    "cur.d3.hook": "Buying an iPhone on EMI just to look cool in the office.",
    "cur.d3.concept": "If the EMI light is Red, the iPhone stays in the store. Separate needs from wants using the 50/30/20 rule.",
    "cur.d3.tool": "Try 'Can I Buy It?'",

    // Day 4
    "cur.d4.title": "The Budget That Actually Works",
    "cur.d4.hook": "You made a budget in January. By February, it was dead.",
    "cur.d4.concept": "Use the 50/30/20 framework — 50% needs, 30% wants, 20% savings. Automate transfers on salary day so discipline isn't required.",
    "cur.d4.tool": "Try the Debt-Free Path",

    // Day 5
    "cur.d5.title": "Tracking Your Net Worth",
    "cur.d5.hook": "You earn ₹80K/month but have no idea if you're getting richer or poorer.",
    "cur.d5.concept": "Net Worth = Assets − Liabilities. Track it monthly. If it's going up, you're winning. If not, today we fix it.",

    // Day 6
    "cur.d6.title": "The Debt Snowball vs. Avalanche",
    "cur.d6.hook": "You have 3 EMIs, a credit card bill, and a loan from a friend. Where do you start?",
    "cur.d6.concept": "Snowball: Pay smallest debt first for quick wins. Avalanche: Pay highest interest first for math efficiency. Pick the one that keeps you motivated.",

    // Day 7
    "cur.d7.title": "The Safety Net (Emergency Fund)",
    "cur.d7.hook": "Your car breaks down or your laptop dies. Do you cry or open your 'Peace of Mind' fund?",
    "cur.d7.concept": "Save 3-6 months of expenses in a liquid fund. This is your financial armor — never invest without it.",
    "cur.d7.tool": "Emergency Fund Calculator",

    // Day 8
    "cur.d8.title": "Good Debt vs. Bad Debt",
    "cur.d8.hook": "A home loan at 8% vs. a credit card at 36%. One builds wealth, the other destroys it.",
    "cur.d8.concept": "Good debt appreciates (home, education). Bad debt depreciates (gadgets, vacations on EMI). Eliminate bad debt first.",

    // Day 9
    "cur.d9.title": "The 8th Wonder of the World (Compounding)",
    "cur.d9.hook": "Sam starts investing at 20, Rahul at 30. Sam ends up with 2x the money with half the effort.",
    "cur.d9.concept": "Compound interest is exponential. ₹5,000/month at 12% for 30 years = ₹1.76 Cr. Start today, not tomorrow.",
    "cur.d9.tool": "Try the Wealth Engine",

    // Day 10
    "cur.d10.title": "SIP: The Automatic Wealth Machine",
    "cur.d10.hook": "You skip coffee for a week and invest ₹500. In 20 years, that weekly sacrifice becomes ₹10 Lakhs.",
    "cur.d10.concept": "Systematic Investment Plans (SIPs) automate discipline. Rupee-cost averaging means you buy more when markets dip.",

    // Day 11
    "cur.d11.title": "The 'Step-Up' Secret",
    "cur.d11.hook": "A flat SIP is a slow lane. Increasing by just ₹500/month every year changes everything.",
    "cur.d11.concept": "Step-Up SIP increases your investment annually with your salary hike. A 10% step-up can double your final corpus.",
    "cur.d11.tool": "Toggle Step-Up in Wealth Engine",

    // Day 12
    "cur.d12.title": "Mutual Funds: Decoded",
    "cur.d12.hook": "'Mutual Funds Sahi Hai' — but which one? There are 2,000+ funds in India alone.",
    "cur.d12.concept": "Equity for growth (5+ years), Debt for stability (1-3 years), Hybrid for balance. Always check the Expense Ratio.",

    // Day 13
    "cur.d13.title": "The Power of Asset Allocation",
    "cur.d13.hook": "Putting all your money in stocks is like putting all eggs in one basket on a roller coaster.",
    "cur.d13.concept": "Diversify across Equity, Debt, Gold, and Real Estate. Your age minus 100 is a rough guide for equity allocation.",

    // Day 14
    "cur.d14.title": "Index Funds: The Lazy Millionaire",
    "cur.d14.hook": "Betting on the top 50 companies (Nifty 50 or S&P 500) is safer than a 'hot tip' from a neighbor.",
    "cur.d14.concept": "Index funds have lower fees, beat 80% of active fund managers over 10 years, and require zero stock-picking skills.",

    // Day 15 (Indian)
    "cur.d15i.title": "The UPI Revolution",
    "cur.d15i.hook": "India processes 12 billion UPI transactions monthly. But digital cash makes us spend 30% more.",
    "cur.d15i.concept": "UPI is powerful but dangerous for impulsive spenders. Set daily limits, use separate accounts for spending vs. saving.",
    "cur.d15.tool": "Debt-Free Path",

    // Day 15 (Global)
    "cur.d15g.title": "Credit Score Secrets",
    "cur.d15g.hook": "Your FICO score decides if you get a house or sleep in your car.",
    "cur.d15g.concept": "Payment history (35%), utilization (30%), credit age (15%). Keep utilization below 30%, never miss a payment.",

    // Day 17 (Indian)
    "cur.d17i.title": "Tax Regime Battle: Old vs. New (2026)",
    "cur.d17i.hook": "The government gives you two tax menus. Choosing wrong costs you ₹50,000+.",
    "cur.d17i.concept": "Old regime rewards deductions (80C, HRA). New regime offers lower slabs but no deductions. Compare both for your salary.",
    "cur.d17.tool": "Try the Tax Planner",

    // Day 17 (Global)
    "cur.d17g.title": "Capital Gains: Tax-Efficient Selling",
    "cur.d17g.hook": "You made profit on stocks but 30% goes to the taxman. Unless you know the rules.",
    "cur.d17g.concept": "Hold for 1+ year for long-term gains tax (lower rate). Use tax-loss harvesting to offset gains. Every country has loopholes — learn yours.",

    // Day 19 (Indian)
    "cur.d19i.title": "Real Estate vs. Stocks: The Great Indian Debate",
    "cur.d19i.hook": "'Buy a flat' says every Indian uncle. But did the flat actually beat Nifty 50?",
    "cur.d19i.concept": "Indian real estate returns 6-8% after maintenance. Nifty 50 returns 12-14%. But real estate offers leverage and emotional security.",
    "cur.d19.tool": "Real Estate Planner",

    // Day 19 (Global)
    "cur.d19g.title": "REITs: Own Property Without the Headache",
    "cur.d19g.hook": "You want rental income but can't afford a ₹1Cr flat. What if you could buy ₹500 worth of buildings?",
    "cur.d19g.concept": "REITs let you invest in commercial real estate with tiny amounts. Get dividends without tenants, maintenance, or brokers.",

    // Day 21 (Indian)
    "cur.d21i.title": "Gold: Asset or Ornament?",
    "cur.d21i.hook": "Your grandmother's gold is worth 5x now. But was it an investment or a wedding expense?",
    "cur.d21i.concept": "Sovereign Gold Bonds (SGBs) give gold returns + 2.5% interest, with zero storage cost. Don't buy physical gold for investment.",
    "cur.d21.tool": "Multi-Asset Compare",

    // Day 21 (Global)
    "cur.d21g.title": "Crypto & Digital Gold: Portfolio Hedge",
    "cur.d21g.hook": "Bitcoin went from $0 to $100K. Is it digital gold or digital gambling?",
    "cur.d21g.concept": "Allocate max 5% of portfolio to crypto. Use dollar-cost averaging. Never invest money you can't afford to lose.",

    // Day 22
    "cur.d22.title": "Insurance: The Unsexy Superpower",
    "cur.d22.hook": "A ₹1 Cr health emergency without insurance. That's not a hospital bill — it's a death sentence for your finances.",
    "cur.d22.concept": "Term insurance (not endowment) for life. Health insurance with ₹10L+ cover. These aren't expenses — they're shields.",

    // Day 23
    "cur.d23.title": "Reading the 'Pulse' (Fundamental Analysis)",
    "cur.d23.hook": "Buying a company is like buying a cow. Does it give milk (Profit) or just eat grass (Debt)?",
    "cur.d23.concept": "Check P/E ratio, Debt-to-Equity, and ROE. A P/E below 20 with rising ROE is a potential gem.",
    "cur.d23.tool": "Open the Stock Lab",

    // Day 24
    "cur.d24.title": "Technical Analysis: Reading the Chart",
    "cur.d24.hook": "The stock chart looks like a heartbeat monitor. Can you read it?",
    "cur.d24.concept": "Support, resistance, moving averages. These patterns repeat because human psychology repeats. Use charts to time entries, not to predict the future.",

    // Day 25
    "cur.d25.title": "Building Your First Portfolio",
    "cur.d25.hook": "You have ₹10,000 to invest. How do you split it across 5 asset classes?",
    "cur.d25.concept": "Start with: 40% Index Fund, 20% Mid-Cap, 15% Gold, 15% Debt Fund, 10% International. Rebalance yearly.",

    // Day 26
    "cur.d26.title": "The Psychology of a Crash",
    "cur.d26.hook": "When the market turns Red, 'Sathis' buy and 'Amateurs' run.",
    "cur.d26.concept": "Every crash in history has recovered. The 2008 crash recovered in 5 years. The 2020 crash recovered in 5 months. Stay invested.",

    // Day 27
    "cur.d27.title": "The Side-Hustle Multiplier",
    "cur.d27.hook": "Your salary is capped. Your side income is not. What if you earned ₹20K extra every month?",
    "cur.d27.concept": "Freelancing, content creation, teaching — any ₹20K/month side hustle invested for 15 years = ₹1 Cr+.",

    // Day 28
    "cur.d28.title": "Retirement Clock: Your Freedom Date",
    "cur.d28.hook": "How much do you need to never work again?",
    "cur.d28.concept": "The 25x Rule: Multiply your annual expenses by 25. That's your retirement number. The 4% withdrawal rule keeps you safe forever.",
    "cur.d28.tool": "Use the Retirement Clock",

    // Day 29
    "cur.d29.title": "Estate Planning: The Gift of Organization",
    "cur.d29.hook": "You've built wealth. But if something happens, does your family know where it all is?",
    "cur.d29.concept": "Create a simple document: bank accounts, investments, insurance policies, nominees. Share it with your spouse. Update it yearly.",

    // Day 30
    "cur.d30.title": "🎓 Graduation Day!",
    "cur.d30.hook": "You started 30 days ago not knowing your net worth. Now you have a portfolio, a plan, and a Vikas Score.",
    "cur.d30.concept": "Take the final Vikas Quiz. Generate your RupeeVikas Certificate and share it on Instagram/LinkedIn. You are now a Vikas Graduate!",
  },
  hi: {
    "cur.title": "30-दिन विकास चैलेंज",
    "cur.subtitle": "हर दिन विकास मेथड: एक हुक, एक कॉन्सेप्ट, और एक टूल।",
    "cur.lessonsComplete": "पाठ पूरे",
    "cur.share": "प्रगति शेयर करें",
    "cur.theHook": "हुक",
    "cur.theConcept": "कॉन्सेप्ट",
    "cur.tryTool": "अभी आज़माएं",
    "cur.graduated": "🎓 आप ग्रेजुएट हो गए!",
    "cur.graduatedDesc": "आपने 30-दिन विकास चैलेंज पूरा किया। अपनी उपलब्धि शेयर करें!",
    "cur.shareCertificate": "WhatsApp पर शेयर करें",
    "cur.phase1": "फेज़ 1: नींव (दिन 1–7)",
    "cur.phase2": "फेज़ 2: ग्रोथ इंजन (दिन 8–14)",
    "cur.phase3": "फेज़ 3: भारतीय vs वैश्विक (दिन 15–21)",
    "cur.phase4": "फेज़ 4: एडवांस्ड मास्टरी (दिन 22–30)",

    "cur.d1.title": "अदृश्य चोर (महंगाई)",
    "cur.d1.hook": "2016 की पुरानी जींस में ₹500 का नोट मिला। तब 5 मूवी टिकट आती थीं। आज? मुश्किल से 1।",
    "cur.d1.concept": "महंगाई चुपचाप आपकी बचत को 6-7% सालाना खा जाती है। अगर आपका पैसा नहीं बढ़ रहा, तो वो मर रहा है।",
    "cur.d1.tool": "इन्फ्लेशन मशीन आज़माएं",
    "cur.d2.title": "आपकी मनी पर्सनालिटी",
    "cur.d2.hook": "एक ही सैलरी पर आपका दोस्त ₹20K बचाता है और आप ज़ीरो — क्यों?",
    "cur.d2.concept": "हर किसी की मनी पर्सनालिटी होती है — खर्चीला, बचतकर्ता, टालनेवाला या संन्यासी।",
    "cur.d3.title": "'फ्लेक्स' जाल (ज़रूरत vs चाहत)",
    "cur.d3.hook": "ऑफिस में कूल दिखने के लिए EMI पर iPhone लेना।",
    "cur.d3.concept": "अगर EMI लाइट Red है, तो iPhone दुकान में ही रहे। 50/30/20 नियम अपनाएं।",
    "cur.d3.tool": "'Can I Buy It?' आज़माएं",
    "cur.d4.title": "बजट जो सच में काम करे",
    "cur.d4.hook": "जनवरी में बजट बनाया। फरवरी तक खत्म।",
    "cur.d4.concept": "50/30/20 फ्रेमवर्क — सैलरी के दिन ऑटो ट्रांसफर सेट करें।",
    "cur.d4.tool": "Debt-Free Path आज़माएं",
    "cur.d5.title": "नेट वर्थ ट्रैक करें",
    "cur.d5.hook": "₹80K कमाते हो लेकिन पता नहीं अमीर हो रहे हो या गरीब।",
    "cur.d5.concept": "नेट वर्थ = एसेट्स − लायबिलिटीज। हर महीने ट्रैक करें।",
    "cur.d6.title": "स्नोबॉल vs एवलांच",
    "cur.d6.hook": "3 EMI, क्रेडिट कार्ड बिल, और दोस्त का कर्ज़। कहाँ से शुरू करें?",
    "cur.d6.concept": "स्नोबॉल: पहले छोटा कर्ज़ चुकाएं। एवलांच: पहले सबसे ऊंचा ब्याज चुकाएं।",
    "cur.d7.title": "सेफ्टी नेट (इमरजेंसी फंड)",
    "cur.d7.hook": "गाड़ी खराब हो गई या लैपटॉप। रोएं या 'पीस ऑफ माइंड' फंड खोलें?",
    "cur.d7.concept": "3-6 महीने का खर्चा लिक्विड फंड में रखें। यह आपका वित्तीय कवच है।",
    "cur.d7.tool": "इमरजेंसी फंड कैलकुलेटर",
    "cur.d8.title": "अच्छा कर्ज़ vs बुरा कर्ज़",
    "cur.d8.hook": "8% पर होम लोन vs 36% पर क्रेडिट कार्ड। एक संपत्ति बनाता है, दूसरा तबाह।",
    "cur.d8.concept": "अच्छा कर्ज़ मूल्य बढ़ाता है (घर, शिक्षा)। बुरा कर्ज़ घटाता है (गैजेट, EMI पर छुट्टी)।",
    "cur.d9.title": "दुनिया का 8वां अजूबा (कंपाउंडिंग)",
    "cur.d9.hook": "सैम 20 साल में शुरू करता है, राहुल 30 में। सैम को आधी मेहनत में दोगुना पैसा मिलता है।",
    "cur.d9.concept": "₹5,000/महीना 12% पर 30 साल = ₹1.76 Cr। आज शुरू करें, कल नहीं।",
    "cur.d9.tool": "वेल्थ इंजन आज़माएं",
    "cur.d10.title": "SIP: ऑटोमैटिक वेल्थ मशीन",
    "cur.d10.hook": "एक हफ्ते कॉफी छोड़ो, ₹500 निवेश करो। 20 साल में ₹10 लाख।",
    "cur.d10.concept": "SIP अनुशासन ऑटोमेट करता है। रूपी-कॉस्ट एवरेजिंग से गिरावट में ज़्यादा यूनिट मिलती हैं।",
    "cur.d11.title": "'स्टेप-अप' सीक्रेट",
    "cur.d11.hook": "फ्लैट SIP स्लो लेन है। हर साल ₹500 बढ़ाना सब बदल देता है।",
    "cur.d11.concept": "10% स्टेप-अप आपका फाइनल कॉर्पस दोगुना कर सकता है।",
    "cur.d11.tool": "वेल्थ इंजन में स्टेप-अप टॉगल करें",
    "cur.d12.title": "म्यूचुअल फंड: डिकोडेड",
    "cur.d12.hook": "'म्यूचुअल फंड सही है' — लेकिन कौन सा? भारत में 2,000+ फंड हैं।",
    "cur.d12.concept": "ग्रोथ के लिए इक्विटी (5+ साल), स्थिरता के लिए डेट (1-3 साल)। Expense Ratio ज़रूर चेक करें।",
    "cur.d13.title": "एसेट एलोकेशन की ताकत",
    "cur.d13.hook": "सारा पैसा स्टॉक्स में = रोलर कोस्टर पर सारे अंडे एक टोकरी में।",
    "cur.d13.concept": "इक्विटी, डेट, गोल्ड और रियल एस्टेट में विविधता लाएं।",
    "cur.d14.title": "इंडेक्स फंड: आलसी करोड़पति",
    "cur.d14.hook": "टॉप 50 कंपनियों (Nifty 50) पर दांव लगाना पड़ोसी के 'हॉट टिप' से सुरक्षित है।",
    "cur.d14.concept": "इंडेक्स फंड कम फीस, 10 साल में 80% एक्टिव मैनेजर्स को हराता है।",
    "cur.d15i.title": "UPI क्रांति",
    "cur.d15i.hook": "भारत में मासिक 12 अरब UPI ट्रांज़ैक्शन। लेकिन डिजिटल कैश 30% ज़्यादा खर्च कराता है।",
    "cur.d15i.concept": "UPI शक्तिशाली लेकिन आवेगी खर्चीलों के लिए खतरनाक। दैनिक लिमिट सेट करें।",
    "cur.d15.tool": "डेट-फ्री पाथ",
    "cur.d15g.title": "क्रेडिट स्कोर सीक्रेट्स",
    "cur.d15g.hook": "आपका FICO स्कोर तय करता है कि आपको घर मिलेगा या नहीं।",
    "cur.d15g.concept": "पेमेंट हिस्ट्री 35%, यूटिलाइज़ेशन 30%। यूटिलाइज़ेशन 30% से नीचे रखें।",
    "cur.d17i.title": "टैक्स रिजीम बैटल: पुराना vs नया (2026)",
    "cur.d17i.hook": "सरकार दो टैक्स मेन्यू देती है। गलत चुनने पर ₹50,000+ का नुकसान।",
    "cur.d17i.concept": "पुराना — डिडक्शन (80C, HRA)। नया — कम स्लैब, कोई डिडक्शन नहीं।",
    "cur.d17.tool": "टैक्स प्लानर आज़माएं",
    "cur.d17g.title": "कैपिटल गेन्स: टैक्स-एफिशिएंट सेलिंग",
    "cur.d17g.hook": "स्टॉक्स में प्रॉफिट किया लेकिन 30% टैक्स वाले ले गए।",
    "cur.d17g.concept": "1+ साल होल्ड करें। टैक्स-लॉस हार्वेस्टिंग से गेन्स ऑफसेट करें।",
    "cur.d19i.title": "रियल एस्टेट vs स्टॉक्स: महान भारतीय बहस",
    "cur.d19i.hook": "'फ्लैट खरीदो' — हर अंकल कहता है। लेकिन क्या फ्लैट ने Nifty 50 को हराया?",
    "cur.d19i.concept": "भारतीय रियल एस्टेट 6-8% रिटर्न। Nifty 50 12-14%। लेकिन रियल एस्टेट लीवरेज देता है।",
    "cur.d19.tool": "रियल एस्टेट प्लानर",
    "cur.d19g.title": "REITs: बिना सिरदर्द प्रॉपर्टी",
    "cur.d19g.hook": "₹1Cr का फ्लैट नहीं ले सकते? ₹500 में बिल्डिंग खरीदो।",
    "cur.d19g.concept": "REITs से छोटी रकम में कमर्शियल रियल एस्टेट में निवेश। डिविडेंड बिना किरायेदार।",
    "cur.d21i.title": "सोना: एसेट या गहना?",
    "cur.d21i.hook": "दादी का सोना 5x हो गया। लेकिन निवेश था या शादी का खर्चा?",
    "cur.d21i.concept": "SGB = सोने का रिटर्न + 2.5% ब्याज, ज़ीरो स्टोरेज कॉस्ट। फिजिकल गोल्ड निवेश के लिए न खरीदें।",
    "cur.d21.tool": "मल्टी-एसेट कंपेयर",
    "cur.d21g.title": "क्रिप्टो और डिजिटल गोल्ड",
    "cur.d21g.hook": "Bitcoin $0 से $100K तक गया। डिजिटल गोल्ड या डिजिटल जुआ?",
    "cur.d21g.concept": "पोर्टफोलियो का अधिकतम 5% क्रिप्टो में। डॉलर-कॉस्ट एवरेजिंग करें।",
    "cur.d22.title": "इंश्योरेंस: अनसेक्सी सुपरपावर",
    "cur.d22.hook": "₹1 Cr हेल्थ इमरजेंसी बिना इंश्योरेंस। वो हॉस्पिटल बिल नहीं — वित्तीय मौत है।",
    "cur.d22.concept": "टर्म इंश्योरेंस (एंडोमेंट नहीं)। हेल्थ इंश्योरेंस ₹10L+ कवर।",
    "cur.d23.title": "'पल्स' पढ़ना (फंडामेंटल एनालिसिस)",
    "cur.d23.hook": "कंपनी खरीदना गाय खरीदने जैसा। दूध देती है (प्रॉफिट) या घास खाती है (कर्ज़)?",
    "cur.d23.concept": "P/E रेशियो, Debt-to-Equity, ROE चेक करें। P/E 20 से कम + बढ़ता ROE = संभावित रत्न।",
    "cur.d23.tool": "स्टॉक लैब खोलें",
    "cur.d24.title": "टेक्निकल एनालिसिस: चार्ट पढ़ना",
    "cur.d24.hook": "स्टॉक चार्ट हार्टबीट मॉनिटर जैसा दिखता है। क्या आप पढ़ सकते हो?",
    "cur.d24.concept": "सपोर्ट, रेज़िस्टेंस, मूविंग एवरेज। ये पैटर्न दोहराते हैं क्योंकि मानव मनोविज्ञान दोहराता है।",
    "cur.d25.title": "पहला पोर्टफोलियो बनाएं",
    "cur.d25.hook": "₹10,000 निवेश करने हैं। 5 एसेट क्लास में कैसे बांटें?",
    "cur.d25.concept": "40% इंडेक्स फंड, 20% मिड-कैप, 15% गोल्ड, 15% डेट, 10% इंटरनेशनल।",
    "cur.d26.title": "क्रैश का मनोविज्ञान",
    "cur.d26.hook": "मार्केट Red होता है — 'साथी' खरीदते हैं, 'एमेच्योर' भागते हैं।",
    "cur.d26.concept": "इतिहास का हर क्रैश रिकवर हुआ। 2020 क्रैश 5 महीने में। निवेशित रहें।",
    "cur.d27.title": "साइड-हसल मल्टीप्लायर",
    "cur.d27.hook": "सैलरी सीमित है। साइड इनकम नहीं। ₹20K एक्स्ट्रा हर महीने?",
    "cur.d27.concept": "₹20K/महीना साइड हसल 15 साल निवेश = ₹1 Cr+।",
    "cur.d28.title": "रिटायरमेंट क्लॉक: फ्रीडम डेट",
    "cur.d28.hook": "फिर कभी काम न करने के लिए कितना चाहिए?",
    "cur.d28.concept": "25x नियम: सालाना खर्चा × 25 = रिटायरमेंट नंबर। 4% विड्रॉल नियम।",
    "cur.d28.tool": "रिटायरमेंट क्लॉक",
    "cur.d29.title": "एस्टेट प्लानिंग: संगठन का उपहार",
    "cur.d29.hook": "आपने दौलत बनाई। लेकिन कुछ हुआ तो परिवार को सब पता है?",
    "cur.d29.concept": "एक सिंपल डॉक्यूमेंट: बैंक अकाउंट, निवेश, इंश्योरेंस, नॉमिनी। स्पाउस से शेयर करें।",
    "cur.d30.title": "🎓 ग्रेजुएशन डे!",
    "cur.d30.hook": "30 दिन पहले नेट वर्थ नहीं पता था। अब पोर्टफोलियो, प्लान और विकास स्कोर है।",
    "cur.d30.concept": "फाइनल विकास क्विज़ दें। RupeeVikas सर्टिफिकेट बनाएं और शेयर करें!",
  },
  kn: {
    "cur.title": "30-ದಿನ ವಿಕಾಸ ಚಾಲೆಂಜ್",
    "cur.subtitle": "ಪ್ರತಿ ದಿನ ವಿಕಾಸ ಮೆಥಡ್: ಒಂದು ಹುಕ್, ಒಂದು ಕಾನ್ಸೆಪ್ಟ್, ಮತ್ತು ಒಂದು ಟೂಲ್.",
    "cur.lessonsComplete": "ಪಾಠಗಳು ಪೂರ್ಣ",
    "cur.share": "ಪ್ರಗತಿ ಹಂಚಿಕೊಳ್ಳಿ",
    "cur.theHook": "ಹುಕ್",
    "cur.theConcept": "ಕಾನ್ಸೆಪ್ಟ್",
    "cur.tryTool": "ಈಗ ಪ್ರಯತ್ನಿಸಿ",
    "cur.graduated": "🎓 ನೀವು ಗ್ರಾಜ್ಯುಯೇಟ್ ಆಗಿದ್ದೀರಿ!",
    "cur.graduatedDesc": "ನೀವು 30-ದಿನ ವಿಕಾಸ ಚಾಲೆಂಜ್ ಪೂರ್ಣಗೊಳಿಸಿದ್ದೀರಿ. ಸಾಧನೆ ಹಂಚಿಕೊಳ್ಳಿ!",
    "cur.shareCertificate": "WhatsApp ನಲ್ಲಿ ಹಂಚಿಕೊಳ್ಳಿ",
    "cur.phase1": "ಫೇಸ್ 1: ಅಡಿಪಾಯ (ದಿನ 1–7)",
    "cur.phase2": "ಫೇಸ್ 2: ಗ್ರೋಥ್ ಎಂಜಿನ್ (ದಿನ 8–14)",
    "cur.phase3": "ಫೇಸ್ 3: ಭಾರತೀಯ vs ಜಾಗತಿಕ (ದಿನ 15–21)",
    "cur.phase4": "ಫೇಸ್ 4: ಅಡ್ವಾನ್ಸ್ಡ್ ಮಾಸ್ಟರಿ (ದಿನ 22–30)",

    "cur.d1.title": "ಅಗೋಚರ ಕಳ್ಳ (ಹಣದುಬ್ಬರ)",
    "cur.d1.hook": "2016ರ ಹಳೆ ಜೀನ್ಸ್‌ನಲ್ಲಿ ₹500 ನೋಟು ಸಿಕ್ಕಿತು. ಆಗ 5 ಸಿನಿಮಾ ಟಿಕೆಟ್ ಬರುತ್ತಿತ್ತು. ಈಗ? ಕಷ್ಟಕ್ಕೆ 1.",
    "cur.d1.concept": "ಹಣದುಬ್ಬರ ವಾರ್ಷಿಕ 6-7% ನಿಮ್ಮ ಉಳಿತಾಯವನ್ನು ತಿನ್ನುತ್ತದೆ. ನಿಮ್ಮ ಹಣ ಬೆಳೆಯದಿದ್ದರೆ, ಅದು ಸಾಯುತ್ತಿದೆ.",
    "cur.d1.tool": "ಇನ್ಫ್ಲೇಶನ್ ಮಷೀನ್ ಪ್ರಯತ್ನಿಸಿ",
    "cur.d2.title": "ನಿಮ್ಮ ಮನಿ ಪರ್ಸನಾಲಿಟಿ",
    "cur.d2.hook": "ಅದೇ ಸಂಬಳದಲ್ಲಿ ಸ್ನೇಹಿತ ₹20K ಉಳಿಸುತ್ತಾನೆ, ನೀವು ಶೂನ್ಯ — ಏಕೆ?",
    "cur.d2.concept": "ಪ್ರತಿಯೊಬ್ಬರಿಗೂ ಮನಿ ಪರ್ಸನಾಲಿಟಿ ಇದೆ — ಖರ್ಚು ಮಾಡುವವ, ಉಳಿಸುವವ, ತಪ್ಪಿಸುವವ.",
    "cur.d3.title": "'ಫ್ಲೆಕ್ಸ್' ಬಲೆ (ಅಗತ್ಯ vs ಆಸೆ)",
    "cur.d3.hook": "ಆಫೀಸ್‌ನಲ್ಲಿ ಕೂಲ್ ಕಾಣಲು EMI ಮೇಲೆ iPhone ಖರೀದಿ.",
    "cur.d3.concept": "EMI ಲೈಟ್ Red ಆಗಿದ್ದರೆ iPhone ಅಂಗಡಿಯಲ್ಲೇ ಇರಲಿ. 50/30/20 ನಿಯಮ ಅನುಸರಿಸಿ.",
    "cur.d3.tool": "'Can I Buy It?' ಪ್ರಯತ್ನಿಸಿ",
    "cur.d4.title": "ನಿಜವಾಗಿ ಕೆಲಸ ಮಾಡುವ ಬಜೆಟ್",
    "cur.d4.hook": "ಜನವರಿಯಲ್ಲಿ ಬಜೆಟ್ ಮಾಡಿದಿರಿ. ಫೆಬ್ರವರಿಗೆ ಸತ್ತುಹೋಯಿತು.",
    "cur.d4.concept": "50/30/20 ಫ್ರೇಮ್‌ವರ್ಕ್ — ಸಂಬಳ ದಿನ ಆಟೋ ಟ್ರಾನ್ಸ್‌ಫರ್ ಸೆಟ್ ಮಾಡಿ.",
    "cur.d4.tool": "Debt-Free Path ಪ್ರಯತ್ನಿಸಿ",
    "cur.d5.title": "ನೆಟ್ ವರ್ತ್ ಟ್ರ್ಯಾಕ್ ಮಾಡಿ",
    "cur.d5.hook": "₹80K ಗಳಿಸುತ್ತೀರಿ ಆದರೆ ಶ್ರೀಮಂತರಾಗುತ್ತಿದ್ದೀರೋ ಬಡವರಾಗುತ್ತಿದ್ದೀರೋ ಗೊತ್ತಿಲ್ಲ.",
    "cur.d5.concept": "ನೆಟ್ ವರ್ತ್ = ಆಸ್ತಿ − ಹೊಣೆಗಾರಿಕೆ. ಪ್ರತಿ ತಿಂಗಳು ಟ್ರ್ಯಾಕ್ ಮಾಡಿ.",
    "cur.d6.title": "ಸ್ನೋಬಾಲ್ vs ಅವಲಾಂಚ್",
    "cur.d6.hook": "3 EMI, ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್ ಬಿಲ್, ಸ್ನೇಹಿತನ ಸಾಲ. ಎಲ್ಲಿಂದ ಶುರು?",
    "cur.d6.concept": "ಸ್ನೋಬಾಲ್: ಸಣ್ಣ ಸಾಲ ಮೊದಲು. ಅವಲಾಂಚ್: ಹೆಚ್ಚಿನ ಬಡ್ಡಿ ಮೊದಲು.",
    "cur.d7.title": "ಸೇಫ್ಟಿ ನೆಟ್ (ಎಮರ್ಜೆನ್ಸಿ ಫಂಡ್)",
    "cur.d7.hook": "ಕಾರ್ ಕೆಟ್ಟಿತು ಅಥವಾ ಲ್ಯಾಪ್‌ಟಾಪ್. ಅಳುತ್ತೀರಾ ಅಥವಾ 'ಶಾಂತಿ' ಫಂಡ್ ತೆರೆಯುತ್ತೀರಾ?",
    "cur.d7.concept": "3-6 ತಿಂಗಳ ಖರ್ಚು ಲಿಕ್ವಿಡ್ ಫಂಡ್‌ನಲ್ಲಿ ಇರಿಸಿ. ಇದು ನಿಮ್ಮ ಆರ್ಥಿಕ ಕವಚ.",
    "cur.d7.tool": "ಎಮರ್ಜೆನ್ಸಿ ಫಂಡ್ ಕ್ಯಾಲ್ಕುಲೇಟರ್",
    "cur.d8.title": "ಒಳ್ಳೆ ಸಾಲ vs ಕೆಟ್ಟ ಸಾಲ",
    "cur.d8.hook": "8% ಹೋಮ್ ಲೋನ್ vs 36% ಕ್ರೆಡಿಟ್ ಕಾರ್ಡ್. ಒಂದು ಸಂಪತ್ತು ಕಟ್ಟುತ್ತೆ, ಇನ್ನೊಂದು ನಾಶ.",
    "cur.d8.concept": "ಒಳ್ಳೆ ಸಾಲ ಮೌಲ್ಯ ಹೆಚ್ಚಿಸುತ್ತೆ (ಮನೆ, ಶಿಕ್ಷಣ). ಕೆಟ್ಟ ಸಾಲ ಕಡಿಮೆ ಮಾಡುತ್ತೆ.",
    "cur.d9.title": "ಜಗತ್ತಿನ 8ನೇ ಅದ್ಭುತ (ಕಂಪೌಂಡಿಂಗ್)",
    "cur.d9.hook": "ಸ್ಯಾಮ್ 20 ವಯಸ್ಸಿನಲ್ಲಿ ಶುರು, ರಾಹುಲ್ 30ರಲ್ಲಿ. ಸ್ಯಾಮ್‌ಗೆ ಅರ್ಧ ಪ್ರಯತ್ನದಲ್ಲಿ ದ್ವಿಗುಣ.",
    "cur.d9.concept": "₹5,000/ತಿಂಗಳು 12%ನಲ್ಲಿ 30 ವರ್ಷ = ₹1.76 Cr. ಇಂದೇ ಶುರು ಮಾಡಿ.",
    "cur.d9.tool": "ವೆಲ್ತ್ ಎಂಜಿನ್ ಪ್ರಯತ್ನಿಸಿ",
    "cur.d10.title": "SIP: ಆಟೋಮ್ಯಾಟಿಕ್ ವೆಲ್ತ್ ಮಷೀನ್",
    "cur.d10.hook": "ಒಂದು ವಾರ ಕಾಫಿ ಬಿಡಿ, ₹500 ಹೂಡಿಕೆ ಮಾಡಿ. 20 ವರ್ಷದಲ್ಲಿ ₹10 ಲಕ್ಷ.",
    "cur.d10.concept": "SIP ಶಿಸ್ತನ್ನು ಸ್ವಯಂಚಾಲಿತಗೊಳಿಸುತ್ತದೆ. ಮಾರುಕಟ್ಟೆ ಕುಸಿತದಲ್ಲಿ ಹೆಚ್ಚು ಯೂನಿಟ್ ಸಿಗುತ್ತೆ.",
    "cur.d11.title": "'ಸ್ಟೆಪ್-ಅಪ್' ರಹಸ್ಯ",
    "cur.d11.hook": "ಫ್ಲಾಟ್ SIP ನಿಧಾನ ಲೇನ್. ಪ್ರತಿ ವರ್ಷ ₹500 ಹೆಚ್ಚಿಸುವುದು ಎಲ್ಲ ಬದಲಿಸುತ್ತೆ.",
    "cur.d11.concept": "10% ಸ್ಟೆಪ್-ಅಪ್ ನಿಮ್ಮ ಅಂತಿಮ ಕಾರ್ಪಸ್ ದ್ವಿಗುಣ ಮಾಡಬಹುದು.",
    "cur.d11.tool": "ವೆಲ್ತ್ ಎಂಜಿನ್‌ನಲ್ಲಿ ಸ್ಟೆಪ್-ಅಪ್ ಟಾಗಲ್ ಮಾಡಿ",
    "cur.d12.title": "ಮ್ಯೂಚುಯಲ್ ಫಂಡ್: ಡಿಕೋಡ್",
    "cur.d12.hook": "'ಮ್ಯೂಚುಯಲ್ ಫಂಡ್ ಸಹಿ ಹೈ' — ಆದರೆ ಯಾವುದು? ಭಾರತದಲ್ಲಿ 2,000+ ಫಂಡ್.",
    "cur.d12.concept": "ಬೆಳವಣಿಗೆಗೆ ಈಕ್ವಿಟಿ (5+ ವರ್ಷ), ಸ್ಥಿರತೆಗೆ ಡೆಟ್. Expense Ratio ಪರಿಶೀಲಿಸಿ.",
    "cur.d13.title": "ಆಸ್ತಿ ಹಂಚಿಕೆ ಶಕ್ತಿ",
    "cur.d13.hook": "ಎಲ್ಲ ಹಣ ಸ್ಟಾಕ್ಸ್‌ನಲ್ಲಿ = ರೋಲರ್ ಕೋಸ್ಟರ್ ಮೇಲೆ ಎಲ್ಲ ಮೊಟ್ಟೆ ಒಂದೇ ಬುಟ್ಟಿಯಲ್ಲಿ.",
    "cur.d13.concept": "ಈಕ್ವಿಟಿ, ಡೆಟ್, ಚಿನ್ನ ಮತ್ತು ರಿಯಲ್ ಎಸ್ಟೇಟ್‌ನಲ್ಲಿ ವೈವಿಧ್ಯ ಮಾಡಿ.",
    "cur.d14.title": "ಇಂಡೆಕ್ಸ್ ಫಂಡ್: ಸೋಮಾರಿ ಕೋಟ್ಯಧಿಪತಿ",
    "cur.d14.hook": "ಟಾಪ್ 50 ಕಂಪನಿ (Nifty 50) ಮೇಲೆ ಪಂತ ನೆರೆಯವರ 'ಹಾಟ್ ಟಿಪ್' ಗಿಂತ ಸುರಕ್ಷಿತ.",
    "cur.d14.concept": "ಇಂಡೆಕ್ಸ್ ಫಂಡ್ ಕಡಿಮೆ ಶುಲ್ಕ, 10 ವರ್ಷದಲ್ಲಿ 80% ಆಕ್ಟಿವ್ ಮ್ಯಾನೇಜರ್ ಸೋಲಿಸುತ್ತೆ.",
    "cur.d15i.title": "UPI ಕ್ರಾಂತಿ",
    "cur.d15i.hook": "ಭಾರತ ತಿಂಗಳಿಗೆ 12 ಬಿಲಿಯನ್ UPI ಟ್ರಾನ್ಸ್‌ಆಕ್ಷನ್. ಆದರೆ ಡಿಜಿಟಲ್ ಕ್ಯಾಶ್ 30% ಜಾಸ್ತಿ ಖರ್ಚು ಮಾಡಿಸುತ್ತೆ.",
    "cur.d15i.concept": "UPI ಶಕ್ತಿಶಾಲಿ ಆದರೆ ಆವೇಗ ಖರ್ಚಿಗೆ ಅಪಾಯ. ದೈನಿಕ ಮಿತಿ ಹೊಂದಿಸಿ.",
    "cur.d15.tool": "ಡೆಟ್-ಫ್ರೀ ಪಾಥ್",
    "cur.d15g.title": "ಕ್ರೆಡಿಟ್ ಸ್ಕೋರ್ ರಹಸ್ಯಗಳು",
    "cur.d15g.hook": "ನಿಮ್ಮ FICO ಸ್ಕೋರ್ ಮನೆ ಸಿಗುತ್ತೋ ಇಲ್ಲವೋ ನಿರ್ಧರಿಸುತ್ತೆ.",
    "cur.d15g.concept": "ಪಾವತಿ ಇತಿಹಾಸ 35%, ಬಳಕೆ 30%. ಬಳಕೆ 30% ಕೆಳಗೆ ಇಡಿ.",
    "cur.d17i.title": "ತೆರಿಗೆ ಪದ್ಧತಿ ಯುದ್ಧ: ಹಳೆ vs ಹೊಸ (2026)",
    "cur.d17i.hook": "ಸರ್ಕಾರ ಎರಡು ತೆರಿಗೆ ಮೆನು ಕೊಡುತ್ತೆ. ತಪ್ಪು ಆಯ್ಕೆ ₹50,000+ ನಷ್ಟ.",
    "cur.d17i.concept": "ಹಳೆ — ಕಡಿತ (80C, HRA). ಹೊಸ — ಕಡಿಮೆ ಸ್ಲ್ಯಾಬ್, ಕಡಿತ ಇಲ್ಲ.",
    "cur.d17.tool": "ಟ್ಯಾಕ್ಸ್ ಪ್ಲಾನರ್ ಪ್ರಯತ್ನಿಸಿ",
    "cur.d17g.title": "ಕ್ಯಾಪಿಟಲ್ ಗೇನ್ಸ್: ತೆರಿಗೆ-ದಕ್ಷ ಮಾರಾಟ",
    "cur.d17g.hook": "ಸ್ಟಾಕ್ಸ್‌ನಲ್ಲಿ ಲಾಭ ಮಾಡಿದಿರಿ ಆದರೆ 30% ತೆರಿಗೆದಾರ ತೆಗೆದುಕೊಂಡ.",
    "cur.d17g.concept": "1+ ವರ್ಷ ಹಿಡಿದುಕೊಳ್ಳಿ. ಟ್ಯಾಕ್ಸ್-ಲಾಸ್ ಹಾರ್ವೆಸ್ಟಿಂಗ್ ಬಳಸಿ.",
    "cur.d19i.title": "ರಿಯಲ್ ಎಸ್ಟೇಟ್ vs ಸ್ಟಾಕ್ಸ್: ಮಹಾನ್ ಭಾರತೀಯ ಚರ್ಚೆ",
    "cur.d19i.hook": "'ಫ್ಲ್ಯಾಟ್ ಖರೀದಿಸಿ' ಎಲ್ಲ ಅಂಕಲ್ ಹೇಳ್ತಾರೆ. ಆದರೆ ಫ್ಲ್ಯಾಟ್ Nifty 50 ಸೋಲಿಸಿತಾ?",
    "cur.d19i.concept": "ಭಾರತೀಯ ರಿಯಲ್ ಎಸ್ಟೇಟ್ 6-8% ರಿಟರ್ನ್. Nifty 50 12-14%.",
    "cur.d19.tool": "ರಿಯಲ್ ಎಸ್ಟೇಟ್ ಪ್ಲಾನರ್",
    "cur.d19g.title": "REITs: ತಲೆನೋವು ಇಲ್ಲದೆ ಪ್ರಾಪರ್ಟಿ",
    "cur.d19g.hook": "₹1Cr ಫ್ಲ್ಯಾಟ್ ಕೊಳ್ಳಲಾಗದೆ? ₹500ರಲ್ಲಿ ಕಟ್ಟಡ ಖರೀದಿಸಿ.",
    "cur.d19g.concept": "REITs ಸಣ್ಣ ಮೊತ್ತದಲ್ಲಿ ಕಮರ್ಷಿಯಲ್ ರಿಯಲ್ ಎಸ್ಟೇಟ್ ಹೂಡಿಕೆ. ಬಾಡಿಗೆದಾರರಿಲ್ಲ.",
    "cur.d21i.title": "ಚಿನ್ನ: ಆಸ್ತಿ ಅಥವಾ ಆಭರಣ?",
    "cur.d21i.hook": "ಅಜ್ಜಿಯ ಚಿನ್ನ 5x ಆಗಿದೆ. ಆದರೆ ಹೂಡಿಕೆಯಾ ಅಥವಾ ಮದುವೆ ಖರ್ಚಾ?",
    "cur.d21i.concept": "SGB = ಚಿನ್ನದ ರಿಟರ್ನ್ + 2.5% ಬಡ್ಡಿ, ಶೂನ್ಯ ಸ್ಟೋರೇಜ್ ವೆಚ್ಚ.",
    "cur.d21.tool": "ಮಲ್ಟಿ-ಆಸೆಟ್ ಕಂಪೇರ್",
    "cur.d21g.title": "ಕ್ರಿಪ್ಟೋ ಮತ್ತು ಡಿಜಿಟಲ್ ಗೋಲ್ಡ್",
    "cur.d21g.hook": "Bitcoin $0 ನಿಂದ $100K. ಡಿಜಿಟಲ್ ಗೋಲ್ಡ್ ಅಥವಾ ಡಿಜಿಟಲ್ ಜೂಜು?",
    "cur.d21g.concept": "ಪೋರ್ಟ್ಫೋಲಿಯೊದ ಗರಿಷ್ಠ 5% ಕ್ರಿಪ್ಟೋನಲ್ಲಿ. ಡಾಲರ್-ಕಾಸ್ಟ್ ಎವರೇಜಿಂಗ್ ಮಾಡಿ.",
    "cur.d22.title": "ಇನ್ಶೂರೆನ್ಸ್: ಅನ್‌ಸೆಕ್ಸಿ ಸೂಪರ್‌ಪವರ್",
    "cur.d22.hook": "₹1 Cr ಹೆಲ್ತ್ ಎಮರ್ಜೆನ್ಸಿ ಇನ್ಶೂರೆನ್ಸ್ ಇಲ್ಲದೆ. ಅದು ಆರ್ಥಿಕ ಸಾವು.",
    "cur.d22.concept": "ಟರ್ಮ್ ಇನ್ಶೂರೆನ್ಸ್ ಜೀವಕ್ಕೆ. ಹೆಲ್ತ್ ₹10L+ ಕವರ್.",
    "cur.d23.title": "'ಪಲ್ಸ್' ಓದುವುದು (ಫಂಡಮೆಂಟಲ್ ಅನಾಲಿಸಿಸ್)",
    "cur.d23.hook": "ಕಂಪನಿ ಖರೀದಿ ಹಸು ಖರೀದಿ ಇದ್ದ ಹಾಗೆ. ಹಾಲು ಕೊಡುತ್ತಾ (ಲಾಭ) ಅಥವಾ ಹುಲ್ಲು ತಿನ್ನುತ್ತಾ (ಸಾಲ)?",
    "cur.d23.concept": "P/E ರೇಶಿಯೋ, Debt-to-Equity, ROE ಪರಿಶೀಲಿಸಿ.",
    "cur.d23.tool": "ಸ್ಟಾಕ್ ಲ್ಯಾಬ್ ತೆರೆಯಿರಿ",
    "cur.d24.title": "ಟೆಕ್ನಿಕಲ್ ಅನಾಲಿಸಿಸ್: ಚಾರ್ಟ್ ಓದುವುದು",
    "cur.d24.hook": "ಸ್ಟಾಕ್ ಚಾರ್ಟ್ ಹಾರ್ಟ್‌ಬೀಟ್ ಮಾನಿಟರ್ ಥರ ಕಾಣುತ್ತೆ. ಓದಬಹುದಾ?",
    "cur.d24.concept": "ಸಪೋರ್ಟ್, ರೆಸಿಸ್ಟೆನ್ಸ್, ಮೂವಿಂಗ್ ಎವರೇಜ್. ಮಾನವ ಮನೋವಿಜ್ಞಾನ ಪುನರಾವರ್ತಿಸುತ್ತೆ.",
    "cur.d25.title": "ಮೊದಲ ಪೋರ್ಟ್ಫೋಲಿಯೊ ನಿರ್ಮಿಸಿ",
    "cur.d25.hook": "₹10,000 ಹೂಡಿಕೆ ಮಾಡಬೇಕು. 5 ಆಸ್ತಿ ವರ್ಗಗಳಲ್ಲಿ ಹೇಗೆ ಹಂಚುವುದು?",
    "cur.d25.concept": "40% ಇಂಡೆಕ್ಸ್ ಫಂಡ್, 20% ಮಿಡ್-ಕ್ಯಾಪ್, 15% ಚಿನ್ನ, 15% ಡೆಟ್, 10% ಅಂತರ್ರಾಷ್ಟ್ರೀಯ.",
    "cur.d26.title": "ಕ್ರ್ಯಾಶ್ ಮನೋವಿಜ್ಞಾನ",
    "cur.d26.hook": "ಮಾರುಕಟ್ಟೆ Red — 'ಸಾಥಿಗಳು' ಖರೀದಿಸ್ತಾರೆ, 'ಎಮೆಚ್ಯೂರ್' ಓಡ್ತಾರೆ.",
    "cur.d26.concept": "ಇತಿಹಾಸದ ಪ್ರತಿ ಕ್ರ್ಯಾಶ್ ರಿಕವರ್ ಆಗಿದೆ. 2020 ಕ್ರ್ಯಾಶ್ 5 ತಿಂಗಳಲ್ಲಿ. ಹೂಡಿಕೆಯಲ್ಲಿ ಇರಿ.",
    "cur.d27.title": "ಸೈಡ್-ಹಸ್ಲ್ ಮಲ್ಟಿಪ್ಲಯರ್",
    "cur.d27.hook": "ಸಂಬಳ ಸೀಮಿತ. ಸೈಡ್ ಆದಾಯ ಸೀಮಿತವಲ್ಲ. ₹20K ಎಕ್ಸ್ಟ್ರಾ ಪ್ರತಿ ತಿಂಗಳು?",
    "cur.d27.concept": "₹20K/ತಿಂಗಳು ಸೈಡ್ ಹಸ್ಲ್ 15 ವರ್ಷ ಹೂಡಿಕೆ = ₹1 Cr+.",
    "cur.d28.title": "ರಿಟೈರ್ಮೆಂಟ್ ಕ್ಲಾಕ್: ಫ್ರೀಡಮ್ ಡೇಟ್",
    "cur.d28.hook": "ಮತ್ತೆಂದೂ ಕೆಲಸ ಮಾಡದಿರಲು ಎಷ್ಟು ಬೇಕು?",
    "cur.d28.concept": "25x ನಿಯಮ: ವಾರ್ಷಿಕ ಖರ್ಚು × 25 = ರಿಟೈರ್ಮೆಂಟ್ ಸಂಖ್ಯೆ.",
    "cur.d28.tool": "ರಿಟೈರ್ಮೆಂಟ್ ಕ್ಲಾಕ್ ಬಳಸಿ",
    "cur.d29.title": "ಎಸ್ಟೇಟ್ ಪ್ಲಾನಿಂಗ್: ಸಂಘಟನೆಯ ಉಡುಗೊರೆ",
    "cur.d29.hook": "ಸಂಪತ್ತು ಕಟ್ಟಿದ್ದೀರಿ. ಆದರೆ ಏನಾದರೂ ಆದರೆ ಕುಟುಂಬಕ್ಕೆ ಎಲ್ಲ ಗೊತ್ತಾ?",
    "cur.d29.concept": "ಸರಳ ಡಾಕ್ಯುಮೆಂಟ್: ಬ್ಯಾಂಕ್ ಖಾತೆ, ಹೂಡಿಕೆ, ಇನ್ಶೂರೆನ್ಸ್, ನಾಮಿನಿ. ಸಂಗಾತಿಯೊಂದಿಗೆ ಹಂಚಿಕೊಳ್ಳಿ.",
    "cur.d30.title": "🎓 ಗ್ರಾಜ್ಯುಯೇಶನ್ ಡೇ!",
    "cur.d30.hook": "30 ದಿನ ಹಿಂದೆ ನೆಟ್ ವರ್ತ್ ಗೊತ್ತಿರಲಿಲ್ಲ. ಈಗ ಪೋರ್ಟ್ಫೋಲಿಯೊ, ಪ್ಲಾನ್ ಮತ್ತು ವಿಕಾಸ ಸ್ಕೋರ್ ಇದೆ.",
    "cur.d30.concept": "ಅಂತಿಮ ವಿಕಾಸ ಕ್ವಿಜ್ ತೆಗೆದುಕೊಳ್ಳಿ. RupeeVikas ಸರ್ಟಿಫಿಕೇಟ್ ರಚಿಸಿ ಮತ್ತು ಹಂಚಿಕೊಳ್ಳಿ!",
  },
};
